import React, { useState } from 'react';
import Header from '../../../components/header';
import Footer from '../../../components/footer';
import styles from './index.module.css';

const accountUrl = 'https://zikoramfb.qoreonline.com/onboarding/type';
const dialUrl = 'tel:*5988%23';
const services = [
  'Check your account balance',
  'Pay bills',
  'Buy airtime and data',
  'Transfer money to any bank',
  'View last few transactions',
  'Open a Zikora MFB account (where supported)',
];
const steps = [
  ['01', 'Dial *5988#', 'Use the phone number registered to your Zikora account.'],
  ['02', 'Choose from the menu', 'Reply with the number for balance, transfer, airtime, bills or support.'],
  ['03', 'Confirm with your PIN', 'Enter your 4-digit USSD PIN and the transaction completes instantly.'],
];
const questions = [
  ['Does USSD banking cost money?', 'Please contact Zikora MFB for current USSD session and transaction charges.'],
  ['Do I need a smartphone?', 'No. Dial *5988# from the phone number linked to your Zikora MFB account on any mobile phone.'],
  ['What if my transaction fails?', 'Contact Zikora MFB customer support with the transaction details for help.'],
];
const Label = ({ children }) => <span className={styles.label}><i aria-hidden="true" />{children}</span>;

export default function UssdBanking() {
  const [openQuestion, setOpenQuestion] = useState(0);
  return <main className={styles.page}>
    <Header solid compactMobile />
    <section className={styles.hero}>
      <div className={styles.heroInner}>
        <Label>USSD Banking</Label>
        <h1>Banking That Works,<br /><em>Without Data</em></h1>
        <p>No smartphone? No internet? No problem. Dial our USSD code and bank on the spot.</p>
        <div className={styles.actions}>
          <a className={styles.primary} href={accountUrl} target="_blank" rel="noopener noreferrer">Open account</a>
          <a className={styles.secondary} href={dialUrl}>Dial *5988# now</a>
        </div>
      </div>
    </section>
    <div className={styles.trustBar}><span>CBN Licensed (090504)</span><span>NDIC Insured</span><span>Works on Any Phone</span><span>No Internet Required</span></div>
    <section className={styles.why}>
      <div className={styles.width}>
        <div><Label>Why USSD banking exists</Label><h2>Banking shouldn’t depend on a smartphone.</h2></div>
        <div className={styles.whyCopy}>
          <p>Not everyone has a smartphone or steady internet. USSD Banking lets customers access their account using any mobile phone. Just dial <strong>*5988#</strong> and follow the prompts.</p>
          <div><span>Why it matters</span><p>Across Anambra, Enugu, Imo, Abia, Ebonyi, and Asaba, many customers work where data isn’t always available. USSD Banking means no one is left out.</p></div>
        </div>
      </div>
    </section>
    <section className={styles.services}>
      <div className={styles.width}>
        <Label>What you can do</Label>
        <h2>The essentials, on any phone.</h2>
        <ol>{services.map((service, index) => <li key={service}><span>0{index + 1}</span><p>{service}</p></li>)}</ol>
      </div>
    </section>
    <section className={styles.steps}>
      <div className={styles.width}>
        <Label>How it works</Label>
        <h2>Dial, choose, confirm.</h2>
        <div className={styles.stepGrid}>{steps.map(([number, title, description]) => <article key={number}><span>{number}</span><h3>{title}</h3><p>{description}</p></article>)}</div>
        <div className={styles.securityNote}>Every session is PIN-protected and ends when you close it. Zikora MFB will never ask for your PIN by phone, SMS or WhatsApp. If your phone is lost, dial the code from a new SIM on your registered number or call customer service to block access.</div>
      </div>
    </section>
    <section className={styles.testimonial}><div className={styles.width}><Label>Customer testimonial</Label><blockquote><p>“Running a business means money needs can come up at any time. Zikora made it easy for me to access support when I needed to restock, and the process was faster than I expected. It has helped me keep my business growing”</p><footer><span aria-hidden="true">●</span><div><strong>Chinedu O.</strong><small>Electronics Trader, Nnewi</small></div></footer></blockquote></div></section>
    <section className={styles.faq}><div className={styles.width}><div><Label>FAQs</Label><h2>Frequently asked questions<br />about USSD Banking</h2><a href="/contact">Have more questions? Contact us →</a></div><div className={styles.questionList}>{questions.map(([question, answer], index) => <div className={styles.question} key={question}><button aria-expanded={openQuestion === index} onClick={() => setOpenQuestion(openQuestion === index ? -1 : index)}>{question}<span aria-hidden="true">{openQuestion === index ? '⌃' : '⌄'}</span></button>{openQuestion === index && <p>{answer}</p>}</div>)}</div></div></section>
    <section className={styles.cta}><div className={styles.width}><Label>Get started</Label><h2>Ready to get started with smarter banking?</h2><p>Dial *5988# from your registered number, or open a Zikora account in minutes.</p><div className={styles.actions}><a className={styles.primary} href={accountUrl} target="_blank" rel="noopener noreferrer">Open account</a><a className={styles.secondary} href={dialUrl}>Dial *5988# now</a></div></div></section>
    <Footer about />
  </main>;
}
